'use strict';

angular.module('licensure.services')
    .factory('Account', ['$http', '$q', '$rootScope', 'Cache', function ($http, $q, $rootScope, Cache) {
        return {
            get: function (args) {
                var d = $q.defer();

                if ($rootScope.offline) {
                    Cache.get('account', 'LICENSURE').then(function (account) {
                        d.resolve(account);
                    });
                }
                else {
                    $http.get(apiLocation + '/api/account', {
                        params: args
                    })
                    .then(function (response) {
                        if (response.data != null) {
                            response.data.PRODUCTNAME = 'LICENSURE';
                            Cache.save('account', response.data, 'PRODUCTNAME').then(function () {
                                d.resolve(response.data);
                            }).catch(function (response) {
                                d.reject(response.data);
                            });
                        }
                        else {
                            d.resolve(null);
                        }
                    })
                    .catch(function (response) {
                        // handle error
                    });
                }

                return d.promise;
            },

            getApplicationCounts: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/account/preview', {
                    params: args
                })
                .then(function (response) {
                    if (response.data != null) {
                        var newUserAccount = angular.copy($rootScope.userAccount);
                        newUserAccount.counts_retrieved = response.data.counts_retrieved;
                        newUserAccount.continue_count = response.data.continue_count;
                        newUserAccount.review_count = response.data.review_count;
                        newUserAccount.checkout_count = response.data.checkout_count;
                        newUserAccount.PRODUCTNAME = 'LICENSURE';
                        Cache.save('account', newUserAccount, 'PRODUCTNAME').then(function () {
                            d.resolve(response.data);
                        });
                    }
                    else {
                        d.resolve(null);
                    }
                })
                .catch(function (response) {
                    // handle error
                });

                return d.promise;
            },

            validate: function (password, user_name) {
                var d = $q.defer();

                $http
                    .post(apiLocation + '/api/account/validate', {
                        password: password,
                        user_name: user_name
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;